/**
 * Zod validation schemas for Character entities
 *
 * Validates character creation requests and character data.
 */

import { z } from 'zod';

/**
 * Character validation
 */
export const CharacterSchema = z.object({
  id: z.string().min(1),
  householdId: z.string().nullable(),
  type: z.enum(['custom', 'readymade']),
  name: z.string().min(1).max(100),
  description: z.string().min(1).max(1000),
  cartoonImageUrl: z.string().url(),
  storyCount: z.number().min(0),
  createdAt: z.date(),
  isActive: z.boolean(),
});

/**
 * CreateCharacterRequest validation
 * Used for POST /createCharacter endpoint
 */
export const CreateCharacterRequestSchema = z.object({
  name: z.string().min(1).max(100),
  photoBase64: z.string().min(100), // Base64 encoded image
  description: z.string().max(500).optional(),
});
